import { Modifier } from '@dnd-kit/core';
import { RefObject } from 'react';

export type TColumn = {
  id: string;
  title: string;
};

export function createContainPaintModifier(
  containerRef: RefObject<HTMLDivElement | null>
): Modifier {
  return ({ transform }) => {
    if (!containerRef.current) return transform;
    const rect = containerRef.current.getBoundingClientRect();
    return { ...transform, x: transform.x - rect.left, y: transform.y - rect.top };
  };
}
